import * as React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Ann from "../img/annWatkins.jpg";
// import Blog from "../img/blog.gif";
// import ReactiveTriadsLogo from "../img/reactive-triads-bodywork-logo.jpg";
import greenReactiveTriadsBodyworkLogo from "../img/greenReactiveTriadsBodyworkLogo.png";
import whiteLotus2 from "../img/whiteLotus2.jpeg";
import midflower75x82 from "../img/midflower75x82.jpg";
import whiteFlowerRandy from "../img/whiteFlowerRandyShepherd.jpg";
import "./routes.css";

const homeBackground = {
  backgroundColor: "#37659D",
  // justifyContent: "center",
};
const parallaxHome = {
  backgroundImage: `url(${whiteLotus2})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  minHeight: "85vh",
  display: "flex",
  alignItems: "center",
};
// Translucent panel over the dark left side of the lotus photo
const heroPanel = {
  maxWidth: "34rem",
  margin: "3rem 5vw",
  padding: "2rem",
  borderRadius: "1rem",
  backgroundColor: "rgba(20, 40, 70, 0.72)",
  backdropFilter: "blur(4px)",
  color: "#FFFFFF",
  boxShadow: "rgba(0, 0, 0, 0.35) 0px 0px 12px 4px",
};
const heroTitle = {
  fontWeight: "bold",
  marginBottom: "0.75rem",
};
const heroTagline = {
  opacity: 0.9,
  marginBottom: "1.5rem",
};
// Deep petal purple: same hue as the lavender tips in flower.jpg (~#877EA9), darkened for white lettering
const omCta = {
  display: "inline-block",
  backgroundColor: "#352B64",
  border: "1px solid rgba(255, 255, 255, 0.7)",
  color: "#FFFFFF",
  fontSize: "1.25rem",
  fontWeight: "bold",
  padding: "0.75rem 1.75rem",
  borderRadius: "0.5rem",
  textDecoration: "none",
};
const omSub = {
  marginTop: "0.5rem",
  marginBottom: "1.75rem",
  fontSize: "0.95rem",
  opacity: 0.9,
};
const heroSecondaryLabel = {
  fontSize: "0.8rem",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  opacity: 0.8,
  marginBottom: "0.5rem",
};
const heroSecondary = {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5rem",
};
const heroSecondaryBtn = {
  color: "#FFFFFF",
  border: "1px solid rgba(255, 255, 255, 0.7)",
  backgroundColor: "rgba(122, 144, 62, 0.85)",
  textDecoration: "none",
  padding: "0.35rem 0.75rem",
  borderRadius: "0.35rem",
  fontSize: "0.9rem",
};
const cardImg = {
  // textAlign: "center",
  padding: ".25rem",
  width: "97px",
  height: "122px",
  marginLeft: "auto",
  marginRight: "auto",
  borderRadius: "1rem",
};
// Source image is 75x82; keep that ratio at a fixed size so it never stretches
const midFlower = {
  width: "60px",
  height: "66px",
  objectFit: "cover",
  borderRadius: "0.75rem",
  margin: "1rem 0 0 1rem",
};
// One shared card style so all nine boxes fill their column and match height
const cardStyle = {
  width: "100%",
  height: "100%",
  boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 5px 5px",
  backgroundColor: "#37659D",
};
const cardText = {
  color: "#FFFFFF",
};
// Group headings above each row of cards
const sectionHeading = {
  color: "#FFFFFF",
  textAlign: "center",
  marginTop: "2.5rem",
  marginBottom: "1rem",
  paddingBottom: "0.5rem",
  borderBottom: "1px solid rgba(255, 255, 255, 0.4)",
};
// Two side-by-side buttons at the bottom of a card
const btnGroup = {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5rem",
};

function Home() {
  return (
    <>
      <div style={homeBackground} className="pb-3">
        <div className="jumbotron section" style={parallaxHome}>
          <div style={heroPanel}>
            <h2 style={heroTitle}>
              Chronic pain relief through postural corrective bodywork
            </h2>
            <p style={heroTagline}>
              Reactive Triads™, lymphatic drainage and somatic bodywork with
              Ann Watkins, MA LMT, in Pawcatuck, CT.
            </p>

            <Link to="/omProject" style={omCta} className="omCta">
              The OM Project ››
            </Link>
            <p style={omSub}>
              Join the world in sounding 3 OMs on all equinoxes and solstices,
              and on New Year&rsquo;s, 30 seconds before the ball drops.
            </p>

            <div style={heroSecondaryLabel}>Conscious Anatomy™ Training</div>
            <div style={heroSecondary}>
              <a
                style={heroSecondaryBtn}
                className="heroSecondaryBtn"
                href="https://www.bodymindspiritanatomy.com/offers/W8nmNqBL/checkout"
                target="_blank"
                rel="noreferrer"
              >
                Free 7 Week Mini Chakra Series
              </a>
              <a
                style={heroSecondaryBtn}
                className="heroSecondaryBtn"
                href="https://www.youtube.com/watch?v=NYKKulvYOeU"
                target="_blank"
                rel="noreferrer"
              >
                Become a Sponge for Anatomy (video)
              </a>
              <a
                style={heroSecondaryBtn}
                className="heroSecondaryBtn"
                href="https://www.bodymindspiritanatomy.com/"
                target="_blank"
                rel="noreferrer"
              >
                Purchase Training
              </a>
            </div>
          </div>
        </div>

        <section
          className="introBand"
          style={{ backgroundImage: `url(${whiteFlowerRandy})` }}
          aria-label="White water lily, photo by Randy Shepherd"
        >
          <div className="introBandText">
            <p>
              Our massage therapy is quite unlike any other type in that it
              corrects the underlying problems associated with chronic pain.
              We work with you to discover the cause and correct it, allowing
              you relief from pain that you have not been able to achieve with
              other forms of medicine and therapies.
            </p>
            <p>
              Our clients usually start experiencing relief after the first
              session with marked results by the third and may require
              maintenance sessions in order to maintain relief. In cases where
              relief does not require maintenance, many of our clients still
              return to achieve enhanced relaxation as well as physical and
              emotional well being.
            </p>
          </div>
        </section>

        <div className="container mt-4">
          {/* About & Services */}
          <h3 style={sectionHeading}>About &amp; Services</h3>
          <div className="row g-4 justify-content-center">
            <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
              <Card className="homeCard" style={cardStyle}>
                <Card.Img style={cardImg} variant="top" src={Ann} />
                <Card.Body>
                  <Card.Title style={cardText}>
                    <strong>Ann Watkins, MA Licensed Massage Therapist</strong>
                  </Card.Title>
                  <Card.Text style={cardText}>
                    Honors in Psychology, MA in Dance Movement Therapy, Licensed
                    Massage Therapist since 1988, published in Massage Magazine.
                    Trained in Lymphatic Drainage; Energy Work: shiatsu,
                    acupressure, polarity; Neuro Muscular Reprogramming Therapy.
                    Developer of the original, advanced postural corrective
                    bodywork principals based in NMR/NKT: Reactive Triads™, a
                    breakthrough in chronic pain relief. LMT # 000393
                  </Card.Text>
                  <Link to="/about">
                    <Button>Read Details ››</Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
              <Card className="homeCard" style={cardStyle}>
                <Card.Img
                  className="reactivetriadsCardTopBackgroundColor"
                  variant="top"
                  src={greenReactiveTriadsBodyworkLogo}
                />
                <Card.Body>
                  <Card.Title style={cardText}>
                    <strong>Reactive Triads™ Chronic Pain Breakthrough</strong>
                  </Card.Title>
                  <Card.Text style={cardText}>
                    Reactive Triads™ are three elements activated in the body
                    that cause a muscle to switch off resulting in muscle pain,
                    nerve pain, limited range of motion. Integrating lymphatic
                    drainage and jolts, Reactive Triads™ are exceptionally
                    effective in solving chronic pain problems due to muscle
                    imbalance caused by injury, whiplash, repetitive motion and
                    stress. Acute and chronic pain relief, postural correction,
                    increased range of motion, mind - body - spirit integration.
                  </Card.Text>
                  <Card.Text style={cardText}>
                    Available as a 2 disc DVD, and taught in upcoming (Neuro)
                    Reactive Triads™ classes.
                  </Card.Text>
                  <div style={btnGroup}>
                    <Link to="/store">
                      <Button>DVD Details ››</Button>
                    </Link>
                    <a
                      href="https://www.bodymindspiritanatomy.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button>Classes &amp; Registration ››</Button>
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
              <Card className="homeCard" style={cardStyle}>
                <Card.Img
                  variant="top"
                  src={midflower75x82}
                  style={midFlower}
                />
                <Card.Body>
                  <Card.Title style={cardText}>
                    <strong>Supervision &amp; Mentoring</strong>
                  </Card.Title>
                  <Card.Text style={cardText}>
                    Classes are ongoing and we are available to help you build a
                    more effectiveness practice and greater confidence in your
                    work through Supervision. We can be anywhere and still be in
                    touch by phone. We can answer your client questions and
                    provide you with helpful guidance- from solidly building
                    your practice to solving problems you are stumped by in your
                    sessions. We have a very successful practice going on 20+
                    years with thousands of hours of experience.
                  </Card.Text>
                  <Link to="/classes">
                    <Button>Read Details and Register ››</Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Free Resources */}
          <h3 style={sectionHeading}>Free Resources</h3>
          <div className="row g-4 justify-content-center">
            <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
              <Card className="homeCard" style={cardStyle}>
                <Card.Img
                  variant="top"
                  src={midflower75x82}
                  style={midFlower}
                />
                <Card.Body>
                  <Card.Title style={cardText}>
                    <strong>A Moment for Yourself</strong>
                  </Card.Title>
                  <Card.Text style={cardText}>
                    Click to receive our very popular "A Moment for Yourself
                    Chakra Series". We have various FREE resources in our
                    on-line library at our Conscious Anatomy™ site. Boosting
                    Your Creativity and Your Calm (ten minute audio meditation
                    by Ann Watkins), sample classes and other resources will
                    become available to you at the Conscious Anatomy™ site
                    following the conclusion of your "A Moment for Yourself"
                    Chakra Series.
                  </Card.Text>
                  <a
                      href="https://www.bodymindspiritanatomy.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                    <Button>Get the Chakra Series ››</Button>
                  </a>
                </Card.Body>
              </Card>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
              <Card className="homeCard" style={cardStyle}>
                <Card.Img
                  variant="top"
                  src={midflower75x82}
                  style={midFlower}
                />
                <Card.Body>
                  <Card.Title style={cardText}>
                    <strong>
                      A Moment for Yourself Archives - Please Share your
                      Thoughts with Us
                    </strong>
                  </Card.Title>
                  <Card.Text style={cardText}>
                    We've made discoveries and have ideas for feeling better and
                    being healthier and more vibrant! We'd love to hear from
                    you. Send us your comments, suggestions, testimonials,
                    thoughts. And let us know if you are interested in hearing
                    about upcoming classes and offerings, sign up top right on
                    our home page!
                  </Card.Text>
                  <Link to="/aMomentForYourself">
                    <Button>Read Details ››</Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Store & Blog */}
          <h3 style={sectionHeading}>Store &amp; Blog</h3>
          <div className="row g-4 justify-content-center">
            <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
              <Card className="homeCard" style={cardStyle}>
                <Card.Img
                  variant="top"
                  src={midflower75x82}
                  style={midFlower}
                />
                <Card.Body>
                  <Card.Title style={cardText}>
                    <strong>Store</strong>
                  </Card.Title>
                  <Card.Text style={cardText}>
                    Visit our secure online store. Find gift certificates, the
                    Reactive Triads™ DVD and all sorts of great items.
                  </Card.Text>
                  <Link to="/store">
                    <Button>Store ››</Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
              <Card className="homeCard" style={cardStyle}>
                <Card.Img
                  variant="top"
                  src={midflower75x82}
                  style={midFlower}
                />
                <Card.Body>
                  <Card.Title style={cardText}>
                    <strong>
                      What's Happening at New Harmony? Check out our blog!
                    </strong>
                  </Card.Title>
                  <Card.Text style={cardText}>
                    Learn about our new staff. Stay informed about upcoming
                    events and look here for class dates and trainings.
                  </Card.Text>
                  <a
                    href="https://newharmonymassage.weebly.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button>Read Blog</Button>
                  </a>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Home;
